import { create } from 'zustand';

type ProjectsState = {
  hasProjects: boolean;
};

const initialState: ProjectsState = {
  hasProjects: false,
};

export const useProjectsStore = create<ProjectsState>(() => ({
  ...initialState,
}));

export const setHasProjects = (hasProjects: boolean) => useProjectsStore.setState({ hasProjects });
